export const addNewUserUrl = (id) => `/api/user/add/:${id}`;
export const editUserUrl = (id) => `/api/user/edit/${id}`;
export const deleteUserUrl = (id) => `/api/user/delete/${id}`;
export const resendEmailUrl = (email) => `/api/user/resend/:${email}`
export const checkStatusUrl = (email) => `/api/user/status/:${email}`
export const getDataByIdUrl = (id) => `/api/user/data/:${id}`
export const verifyStatusUrl = (id) => `/api/user/verify/:${id}`
